export function MinusSign(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 27 2'
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      {...props}
    >
      <path stroke='currentColor' strokeWidth='1.5' d='M25.927 1h-25' />
    </svg>
  );
}
